import { ObjectPathFieldGroup } from '@features/onboarding/utils/pathResolver';

// TODO need refactoring e.t.c
export const MEDICAL_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "General Info",
    items: [
      {
        label: "Plan Name",
        path: "name",
      },
      {
        label: "Plan Type",
        path: "type",
      },
    ],
  },
  {
    title: "Basic Plan Costs",
    items: [
      {
        label: "Individual Deductible (In-Network)",
        path: "details.coverage.Deductible (Individual) - In Network",
      },
      {
        label: "Family Deductible (In-Network)",
        path: "details.coverage.Deductible (Family) - In Network",
      },
      {
        label: "In-Network Coinsurance % (Plan pays/You pay)",
        path: "details.coverage.Coinsurance % (Plan pays/Member Pays) - In Network",
      },
      {
        label: "Out-of-Network Coinsurance % (Plan pays/You pay)",
        path: "details.coverage.Coinsurance % (Plan pays/Member Pays) - Out of Network",
      },
      {
        label: "Individual Max Out-of-Pocket (In-Network)",
        path: "details.coverage.Out of Pocket Maximum (Individual) - In Network",
      },
      {
        label: "Family Max Out-of-Pocket (In-Network)",
        path: "details.coverage.Out of Pocket Maximum (Family) - In Network",
      },
    ],
  },
  {
    title: "Doctor Visits",
    items: [
      {
        label: "Primary Care Visit (In-Network)",
        path: "details.coverage.Primary Care Copay - In Network",
      },
      {
        label: "Primary Care Visit (Out-of-Network)",
        path: "details.coverage.Primary Care Copay - Out of Network",
      },
      {
        label: "Specialist Visit (In-Network)",
        path: "details.coverage.Specialist Copay - In Network",
      },
      {
        label: "Specialist Visit (Out-of-Network)",
        path: "details.coverage.Specialist Copay - Out of Network",
      },
      {
        label: "Chiropractic Visit (In-Network)",
        path: "details.coverage.Chiropractic Care Copay - In Network",
      },
      {
        label: "Chiropractic Visit (Out-of-Network)",
        path: "details.coverage.Chiropractic Care Copay - Out of Network",
      },
      {
        label: "Urgent Care Visit",
        path: "details.coverage.Urgent Care Copay",
      },
      {
        label: "Inpatient Hospital Stay",
        path: "details.coverage.Inpatient Hospital Stay",
      },
      {
        label: "Emergency Room Visit",
        path: "details.coverage.Emergency Room",
      },
    ],
  },
  {
    title: "Prescription Drugs",
    items: [
      {
        label: "Drug Deductible",
        path: "details.coverage.Prescription Drug Deductible",
      },
      {
        label: "Generic Drugs (In-Network Pharmacy)",
        path: "details.coverage.Generic medication (30-day supply) from a pharmacy in your plan’s network",
      },
      {
        label: "Preferred Brand Drugs (In-Network Pharmacy)",
        path: "details.coverage.Brand-name medication that’s on your plan’s preferred list (30-day supply from an in-network pharmacy)",
      },
      {
        label: "Non-Preferred Brand Drugs (In-Network Pharmacy)",
        path: "details.coverage.Brand-name medication that’s not on your plan’s preferred list (30-day supply) from an in-network pharmacy)",
      },
    ],
  },
  // {
  //   title: "Doctor Visits",
  //   items: [
  //     {
  //       label: "Chiropractic Visit (In-Network)",
  //       path: "details.coverage.Chiropractic Care Copay - In Network",
  //     },
  //     {
  //       label: "Chiropractic Visit (Out-of-Network)",
  //       path: "details.coverage.Chiropractic Care Copay - Out of Network",
  //     },
  //     {
  //       label: "Urgent Care Visit",
  //       path: "details.coverage.Urgent Care Copay",
  //     },
  //     {
  //       label: "Urgent Care Visit",
  //       path: "details.coverage.Urgent Care Copay",
  //     },
  //     {
  //       label: "Inpatient Hospital Stay",
  //       path: "details.coverage.Inpatient Hospital Stay",
  //     },
  //     {
  //       label: "Emergency Room Visit",
  //       path: "details.coverage.Emergency Room",
  //     },
  //     {
  //       label: "Non-Preferred Brand Drugs(In-Network Pharmacy)",
  //       path: "details.coverage.Specialty Drugs - Network Provider",
  //     },
  //   ]
  // }
];

// Dental Plan Field Groups (extracted from Simplified_Dental_Plan_Comparison_V2_2025.csv)
export const DENTAL_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Basic Plan Costs",
    items: [
      {
        label: "Coinsurance: Your share of the bill (In Network)",
        path: "details.coverage.Coinsurance - In Network",
      },
      {
        label: "Coinsurance: Your share of the bill (Out of Network)",
        path: "details.coverage.Coinsurance - Out of Network",
      },
      {
        label: "Annual Deductible: What you pay before coverage starts (In Network)",
        path: "details.coverage.Annual Individual / Family Deductible - In Network",
      },
      {
        label: "Annual Deductible: What you pay before coverage starts (Out of Network)",
        path: "details.coverage.Annual Individual / Family Deductible - Out of Network",
      },
      {
        label: "Max insurance will pay this year (In-Network)",
        path: "details.coverage.Annual Individual Maxium Benefit - In Network",
      },
      {
        label: "Max insurance will pay this year (Out of Network)",
        path: "details.coverage.Annual Individual Maxium Benefit - Out of Network",
      },
    ],
  },
  {
    title: "Procedures",
    items: [
      {
        label: "Routine dental checkup (In-Network)",
        path: "details.preventiveServices.Periodic Oral Evaluation - In Network",
      },
      {
        label: "Routine dental checkup (Out-of-Network)",
        path: "details.preventiveServices.Periodic Oral Evaluation - Out of Network",
      },
      {
        label: "Full mouth X-rays (In-Network)",
        path: "details.basicServices.Complete Series/ Panoramic X-Rays - In Network",
      },
      {
        label: "Full mouth X-rays (Out-of-Network)",
        path: "details.basicServices.Complete Series/ Panoramic X-Rays - Out of Network",
      },
      {
        label: "Emergency pain relief/treatment (In-Network)",
        path: "details.basicServices.Emergency Palliative Treatment - In Network",
      },
      {
        label: "Emergency pain relief/treatment (Out-of-Network)",
        path: "details.basicServices.Emergency Palliative Treatment - Out of Network",
      },
      {
        label: "Fillings (In-Network)",
        path: "details.basicServices.Basic Restorative Services (amalgam, composite resin, acrylic, synthetic or plastic fillings) - In Network",
      },
      {
        label: "Fillings (Out-of-Network)",
        path: "details.basicServices.Basic Restorative Services (amalgam, composite resin, acrylic, synthetic or plastic fillings) - Out of Network",
      },
      {
        label: "Basic tooth removal (In-Network)",
        path: "details.basicServices.Simple Extractions - In Network",
      },
      {
        label: "Basic tooth removal (Out-of-Network)",
        path: "details.basicServices.Simple Extractions - Out of Network",
      },
      {
        label: "Gum cleaning (In-Network)",
        path: "details.basicServices.Periodontal Maintenance - In Network",
      },
      {
        label: "Gum cleaning (Out-of-Network)",
        path: "details.basicServices.Periodontal Maintenance - Out of Network",
      },
      {
        label: "Surgical tooth removal (In-Network)",
        path: "details.majorServices.Surgical Extractions and Removal of Impacted Teeth - In Network",
      },
      {
        label: "Surgical tooth removal (Out-of-Network)",
        path: "details.majorServices.Surgical Extractions and Removal of Impacted Teeth - Out of Network",
      },
      {
        label: "Root canals (In-Network)",
        path: "details.majorServices.Non-Surgical Endodontics - In Network",
      },
      {
        label: "Root canals (Out-of-Network)",
        path: "details.majorServices.Non-Surgical Endodontics - Out of Network",
      },
      {
        label: "Tooth caps and covers (In-Network)",
        path: "details.majorServices.Inlays/Onlays/Crowns - In Network",
      },
      {
        label: "Tooth caps and covers (Out-of-Network)",
        path: "details.majorServices.Inlays/Onlays/Crowns - Out of Network",
      },
      {
        label: "Tooth replacements (In-Network)",
        path: "details.majorServices.Bridges - In Network",
      },
      {
        label: "Tooth replacements (Out-of-Network)",
        path: "details.majorServices.Bridges - Out of Network",
      },
    ],
  },
];

// Vision Plan Field Groups (extracted from Simplified_Vision_Plan_Comparison_V2_2025.csv)
export const VISION_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Coverage Details",
    items: [
      {
        label: "Exams Copay",
        path: "details.coverage.Exams Copay",
      },
      {
        label: "Materials Copay (waived for contact lenses)",
        path: "details.coverage.Materials Copay (waived for contact lenses)",
      },
      {
        label: "Eye Exam Coverage - In Network",
        path: "details.coverage.Eye Exam Covereage - In Network",
      },
      {
        label: "Eye Exam Coverage - Out of Network",
        path: "details.coverage.Eye Exam Covereage - Out of Network",
      },
      {
        label: "Single Vision Lenses - In Network",
        path: "details.coverage.Single Vision Lenses - In Network",
      },
      {
        label: "Single Vision Lenses - Out of Network",
        path: "details.coverage.Single Vision Lenses - Out of Network",
      },
      {
        label: "Lined Bifocal Lenses - In Network",
        path: "details.coverage.Lined Bifocal Lenses - In Network",
      },
      {
        label: "Lined Bifocal Lenses - Out of Network",
        path: "details.coverage.Lined Bifocal Lenses - Out of Network",
      },
      {
        label: "Lined Trifocal Lenses - In Network",
        path: "details.coverage.Lined Trifocal Lenses - In Network",
      },
      {
        label: "Lined Trifocal Lenses - Out of Network",
        path: "details.coverage.Lined Trifocal Lenses - Out of Network",
      },
      {
        label: "Lenticular - In Network",
        path: "details.coverage.Lenticular - In Network",
      },
      {
        label: "Lenticular - Out of Network",
        path: "details.coverage.Lenticular - Out of Network",
      },
      {
        label: "Frames - In Network",
        path: "details.coverage.Frames - In Network",
      },
      {
        label: "Frames - Out of Network",
        path: "details.coverage.Frames - Out of Network",
      },
      {
        label: "Costco, Walmart, and Sam's Club Frame Allowance - In Network",
        path: "details.coverage.Costco, Walmart, and Sam's Club Frame Allowance- In Network",
      },
      {
        label: "Contact Lenses (elective) - In Network",
        path: "details.coverage.Contact Lenses (elective) - Out of Network",
      },
      {
        label: "Contact Lenses (elective) - Out of Network",
        path: "details.coverage.Contact Lenses (elective) - Out of Network",
      },
      {
        label: "Contact Lenses (medically necessary) - In Network",
        path: "details.coverage.Contact Lenses (medically necessary) - In Network",
      },
      {
        label: "Contact Lenses (medically necessary) - Out of Network",
        path: "details.coverage.Contact Lenses (medically necessary) - Out of Network",
      },
      {
        label: "Contact Lenses (evaluation and fitting) - In Network",
        path: "details.coverage.Contact Lenses (evaluation and fitting) - In Network",
      },
      {
        label: "Contact Lenses (evaluation and fitting) - Out of Network",
        path: "details.coverage.Contact Lenses (evaluation and fitting) - Out of Network",
      },
      {
        label: "Laser Correction Surgery Discount - In Network",
        path: "details.coverage.Laser Correction Surgery Discount - In Network",
      },
      {
        label: "Laser Correction Surgery Discount - Out of Network",
        path: "details.coverage.Laser Correction Surgery Discount - Out of Network",
      },
    ],
  },
  {
    title: "Service Frequencies",
    items: [
      {
        label: "Exams",
        path: "details.serviceFrequencies.Exams",
      },
      {
        label: "Lenses (for glasses or contact lenses)***",
        path: "details.serviceFrequencies.Lenses (for glasses or contact lenses)***",
      },
      {
        label: "Frames",
        path: "details.serviceFrequencies.Frames",
      },
      {
        label: "Network Discounts (glasses and contact lens professional service)",
        path: "details.serviceFrequencies.Network Discounts (glasses and contact lens professional service)",
      },
      {
        label: "Comprehensive Oral Evaluation - In Network",
        path: "details.serviceFrequencies.Comprehensive Oral Evaluation - In Network",
      },
      {
        label: "Comprehensive Oral Evaluation - Out of Network",
        path: "details.serviceFrequencies.Comprehensive Oral Evaluation - Out of Network",
      },
    ],
  },
];

// Accident Plan Field Groups (extracted from Simplified_Accident_Plan_Comparison_V2_2025.csv)
export const ACCIDENT_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Coverage Basics",
    items: [
      {
        label: "Accidental Death",
        path: "details.lifeAndDismembermentLosses.Accidental Death - Employee",
      },
      {
        label: "Accidental Death - Travel: If you die in an accident on a bus, train, plane, or similar, the insurance pays extra.",
        path: "details.lifeAndDismembermentLosses.Accidental Death Common Carrier (If a person wo is covered dies in an accident while riding a commercial vehicle, like a plane, train, bus, ferry, or subway, the insurance pays a larger benefit than a standard accidental death) - Employee",
      },
    ],
  },
  {
    // lifeAndDismembermentLosses
    title: "Accidental Dismemberment (partial list)",
    items: [
      {
        label: "Loss of one hand, foot, leg, or arm",
        path: "details.accidentalDismemberment.Loss of hand — one hand, Loss of foot — one foot, Loss of leg — one leg or loss of arm — one arm - Employee",
      },
      {
        label: "Loss of one finger or toe",
        path: "details.accidentalDismemberment.Loss of a finger or loss of a toe — one finger or one toe - Employee",
      },
      {
        label: "Loss of hearing or loss of an ear — one ear",
        path: "details.accidentalDismemberment.Loss of hearing or loss of an ear — one ear - Employee",
      },
      {
        label: "Loss of sight or loss of an eye — one eye",
        path: "details.accidentalDismemberment.Loss of sight or loss of an eye — one eye - Employee",
      },
    ],
  },
  {
    title: "Dislocations (partial list)",
    items: [
      {
        label: "Hip (surgery required /no surgery required)",
        path: "details.dislocations.Hip (surgery required /no surgery required) - Employee",
      },
      {
        label: "Shoulder",
        path: "details.dislocations.Shoulder - Employee",
      },
      {
        label: "Knee, ankle or bones of the foot",
        path: "details.dislocations.Knee, ankle or bones of the foot - Employee",
      },
      {
        label: "Elbow or wrist",
        path: "details.dislocations.Elbow or wrist - Employee",
      },
      {
        label: "Finger(s) or toe(s)",
        path: "details.dislocations.Finger(s) or toe(s) - Employee",
      },
    ],
  },
  {
    title: "Fractures (partial list)",
    items: [
      {
        label: "Cracked or crushed skull (serious head injury)",
        path: "details.fractures.Skull (depressed) - Employee",
      },
      {
        label: "Hip or thigh",
        path: "details.fractures.Hip or thigh - Employee",
      },
      {
        label: "Leg (tibia or fibula)",
        path: "details.fractures.Leg (tibia or fibula) - Employee",
      },
      {
        label: "Knee cap",
        path: "details.fractures.Knee cap - Employee",
      },
      {
        label: "Ankle",
        path: "details.fractures.Ankle - Employee",
      },
      {
        label: "Foot",
        path: "details.fractures.Foot - Employee",
      },
      {
        label: "Upper jaw or upper arm",
        path: "details.fractures.Upper jaw or upper arm - Employee",
      },
      {
        label: "Forearm",
        path: "details.fractures.Forearm - Employee",
      },
      {
        label: "Hand",
        path: "details.fractures.Hand - Employee",
      },
      {
        label: "Rib, finger, toe or tailbone",
        path: "details.fractures.Rib, finger, toe or coccyx - Employee",
      },
      {
        label: "Bones of face or nose",
        path: "details.fractures.Bones of face or nose - Employee",
      },
    ],
  },
  {
    title: "Surgery (partial list)",
    items: [
      {
        label: "Other surgery with general anesthesia",
        path: "details.surgery.Miscellaneous surgery requiring general anesthesia not otherwise listed (once per 24-hour period, even though multiple surgical procedures may be performed) - Employee",
      },
      {
        label: "Surgery with a large cut",
        path: "details.surgery.Open surgery - Employee",
      },
      {
        label: "Exploratory surgery or cleaning out damaged tissue",
        path: "details.surgery.Exploratory surgery or debridement - Employee",
      },
      {
        label: "Tendon/Ligament/Rotator cuff tear",
        path: "details.surgery.Tendon/Ligament/Rotator cuff tear - Employee",
      },
      {
        label: "Torn knee cartilage",
        path: "details.surgery.Torn knee cartilage - Employee",
      },
    ],
  },
  {
    title: "Medical Services (partial list)",
    items: [
      {
        label: "One diagnostic test per year (like MRI, CT, EKG, etc.)",
        path: "details.medicalServices.Diagnostic exam (one-time per benefit year): Arteriogram, angiogram, CT, CAT, EKG, EEG or MRI - Employee",
      },
      {
        label: "One X-ray per accident per year",
        path: "details.medicalServices.Diagnostic exam (one-time per benefit year): X-ray (once per covered accident) - Employee",
      },
      {
        label: "One emergency visit (not ER or urgent care) per accident",
        path: "details.medicalServices.Accident emergency treatment (non-ER or non-urgent care facility) (one time per covered accident) - Employee",
      },
    ],
  },
];

// Critical Illness Plan Field Groups (extracted from Simplified_CriticalIllness_Plan_Comparison_V2_2025.csv)
export const CRITICAL_ILLNESS_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Covered Conditions",
    items: [
      {
        label: "Heart Attack",
        path: "details.coverage.Heart Attack - Recurrence Benefit Percentages",
      },
      {
        label: "Stroke",
        path: "details.coverage.Stroke - Benefit Percentages",
      },
      {
        label: "Major organ failure",
        path: "details.coverage.Major organ failure - Benefit Percentages",
      },
      {
        label: "End-stage heart failure",
        path: "details.coverage.End-stage heart failure - Benefit Percentages",
      },
      {
        label: "End-stage kidney disease",
        path: "details.coverage.End-stage kidney disease - Benefit Percentages",
      },
      {
        label: "Occupational infectious disease",
        path: "details.coverage.Occupational infectious disease - Benefit Percentages",
      },
      {
        label: "Coronary Artery Bypass",
        path: "details.coverage.Coronary Artery Bypass - Benefit Percentages",
      },
      {
        label: "Angioplasty",
        path: "details.coverage.Angioplasty - Benefit Percentages",
      },
      {
        label: "Invasive Cancer",
        path: "details.coverage.Invasive Cancer - Benefit Percentages",
      },
      {
        label: "Early-stage cancer that hasn't spread",
        path: "details.coverage.Cancer in Situ - Benefit Percentages",
      },
      {
        label: "Skin Cancer",
        path: "details.coverage.Skin Cancer - Benefit Percentages",
      },
      {
        label: "Coma",
        path: "details.coverage.Coma - Benefit Percentages",
      },
      {
        label: "Paralysis",
        path: "details.coverage.Paralysis - Benefit Percentages",
      },
      {
        label: "Severe Burns",
        path: "details.coverage.Severe Burns - Benefit Percentages",
      },
      {
        label: "Advanced ALS/Lou Gehrig's Disease",
        path: "details.coverage.Advanced ALS/Lou Gehrig’s Disease - Benefit Percentages",
      },
      {
        label: "Advanced Alzheimer's Disease",
        path: "details.coverage.Advanced Alzheimer's Disease- Benefit Percentages",
      },
      {
        label: "Advanced Parkinson's Disease",
        path: "details.coverage.Advanced Parkinson's Disease - Benefit Percentages",
      },
      {
        label: "Blindness",
        path: "details.coverage.Blindness - Benefit Percentages",
      },
      {
        label: "Complete Loss of Hearing",
        path: "details.coverage.Complete Loss of Hearing - Benefit Percentages",
      },
      {
        label: "Loss of Speech",
        path: "details.coverage.Loss of Speech - Benefit Percentages",
      },
    ],
  },
  {
    title: "Childhood Specific Diseases (partial list)",
    items: [
      {
        label: "Cerebral Palsy",
        path: "details.childhoodSpecificDiseases.Cerebral Palsy - Benefit Percentages",
      },
      {
        label: "Cystic Fibrosis",
        path: "details.childhoodSpecificDiseases.Cystic Fibrosis - Benefit Percentages",
      },
      {
        label: "Type 1 Diabetes",
        path: "details.childhoodSpecificDiseases.Type 1 Diabetes Mellitus - Benefit Percentages",
      },
      {
        label: "Muscular Dystrophy",
        path: "details.childhoodSpecificDiseases.Muscular Dystrophy - Benefit Percentages",
      },
      {
        label: "Down Syndrome",
        path: "details.childhoodSpecificDiseases.Down Syndrome - Benefit Percentages",
      },
      {
        label: "Spina Bifida",
        path: "details.childhoodSpecificDiseases.Spina Bifida - Benefit Percentages",
      },
      {
        label: "Cleft Lip/Palate",
        path: "details.childhoodSpecificDiseases.Cleft Lip/Palate - Recurrence Benefit Percentages",
      },
    ],
  },
];

// Hospital Plan Field Groups (extracted from Simplified_Hospital_Plan_Comparison_V2_2025.csv)
export const HOSPITAL_FIELD_GROUPS: ObjectPathFieldGroup[] = [
  {
    title: "Included benefits",
    items: [
      {
        label: "First Day Hospital - Pays for your first day in the hospital",
        path: "details.benefits.First Day Hospital - Benefit Amount",
      },
      {
        label: "First Day ICU Stay - Pays extra for your first day in intensive care",
        path: "details.benefits.First Day Hospital Intensive Care Unit (ICU) Confinement - Benefit Amount",
      },
      {
        label: "Daily Hospital Stay - Pays for each full day you're in the hospital",
        path: "details.benefits.Daily Hospital Confinement - Benefit Amount",
      },
      {
        label: "Daily ICU Stay - Pays more for each day in intensive care",
        path: "details.benefits.Daily Hospital ICU Confinement - Benefit Amount",
      },
      {
        label: "Daily Rehab Stay - Pays for each day in a rehab unit",
        path: "details.benefits.Daily Hospital Rehabilitation Unit - Benefit Amount",
      },
      {
        label: "Daily Baby Nursery Stay - Pays for each day your newborn stays in the nursery",
        path: "details.benefits.Daily Well Baby Nursery Confinement - Benefit Amount",
      },
      {
        label: "Yearly Wellness Visit - Pays for your annual checkup or screening",
        path: "details.benefits.Annual Wellness Screening - Benefit Amount",
      },
      {
        label: "Emergency Room (Accident Only) - Pays if you go to the ER after an accident",
        path: "details.benefits.Emergency Room Treatment (accident only) - Benefit Amount",
      },
      {
        label: "Daily Family Care - Pays for help taking care of your family while you're hospitalized",
        path: "details.benefits.Daily Family Care - Benefit Amount",
      },
      {
        label: "Daily Lodging - Pays for a hotel if a loved one travels to be near you",
        path: "details.benefits.Daily Lodging - Benefit Amount",
      },
      {
        label: "Daily Travel - Pays for your transportation to get care",
        path: "details.benefits.Daily Transportation - Benefit Amount",
      },
    ],
  },
];

// Master mapping of all field groups by category
export const CATEGORY_FIELD_GROUPS: Record<string, ObjectPathFieldGroup[]> = {
  'Major Medical': MEDICAL_FIELD_GROUPS,
  'Dental': DENTAL_FIELD_GROUPS,
  'Vision': VISION_FIELD_GROUPS,
  'Accident': ACCIDENT_FIELD_GROUPS,
  'Critical Illness': CRITICAL_ILLNESS_FIELD_GROUPS,
  'Hospital Indemnity': HOSPITAL_FIELD_GROUPS,
};